import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import { Storage } from 'aws-amplify'
import { getVideoEmbedUrl } from 'config/helpers/Helpers'
import Typography from '@material-ui/core/Typography'

function Project(props) {
    const project = props.project

    // const [image, setImage] = useState(null)

    // useEffect(() => {
    //     getImage()
    // }, [])

    // async function getImage() {
    //     if (project.image) {
    //         let image = await Storage.get(project.image)
    //         //console.log(image)
    //         setImage(image)
    //     }
    // }

    return (
        <Box className='project'>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    {project.image && 
                        <>
                            {project.type === 'Image' &&
                                <img src={project.image} width='200px' style={{ borderRadius: '4px' }} />
                            }
                            {project.type === 'Video' &&
                                <>
                                    {(project.image.includes('youtube.com') || project.image.includes('youtu.be') || project.image.includes('vimeo.com')) ? (
                                        <iframe
                                            width='80%'
                                            height='200'
                                            src={getVideoEmbedUrl(project.image)}
                                            frameBorder='0'
                                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                            allowFullScreen
                                            title='Case Study Video'
                                            style={{ marginBottom: '1rem', borderRadius: '4px' }}
                                        />
                                    ) : (
                                        <video width='80%' height='auto' controls style={{ borderRadius: '4px' }}>
                                            <source src={project.image} type='video/mp4' />
                                            Your browser does not support the video tag.
                                        </video>
                                    )}
                                </>
                            }
                        </>
                    }
                </Grid>
                <Grid item xs={12} md={8}>
                    <Box>
                        <h4>{project.category}{project.county ? ` (${project.county})` : ''}</h4>
                    </Box>
                    <Box style={{color: '#8898aa'}}>
                        <div dangerouslySetInnerHTML={{ __html: project.description }} />
                    </Box>
                    {/* Structured fields display */}
                    {(project.panels || project.costAfterGrant || project.annualSavings || project.paybackPeriod) && (
                        <Box mt={2}>
                            {project.panels && (
                                <p>
                                    <strong>How many panels:</strong> {project.panels}
                                </p>
                            )}
                            {project.costAfterGrant && (
                                <p>
                                    <strong>Cost after grant (€):</strong> {project.costAfterGrant}
                                </p>
                            )}
                            {project.annualSavings && (
                                <p>
                                    <strong>Estimated annual electricity savings (€):</strong> {project.annualSavings}
                                </p>
                            )}
                            {project.paybackPeriod && (
                                <p>
                                    <strong>Payback period (years):</strong> {project.paybackPeriod}
                                </p>
                            )}
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
}

export default Project